import { render } from "./HistoryLog.vue?vue&type=template&id=7b2ec364"
import script from "./HistoryLog.vue?vue&type=script&lang=js"
export * from "./HistoryLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__